import { EntityService } from './EntityService';

import config from '../config.json';
import axios from 'axios';
import { LogLevel } from "@azure/msal-browser";

export class ClientService extends EntityService {
    constructor(){
        super('clients');
    }

    getCurrentClientFromURL = async () => {
        const { origin, pathname } = window.location;
        const host = origin; 
        const path = pathname.split("/")[1] || "";
        try {
            return (await axios.post(`${config.BASE_URL}urlresolver`, {host, path})).data;    
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    getGATrackingId = (client) => {
        return client ? client.config.googleAnalyticsTrackingId || "" : "";
    }

    hasGAConfigured = (client) => {
        return client && (client.config.googleAnalyticsTrackingId || "") !== "";
    }

    isADB2C = (client) => {
        return client && (client.config.authenticationType || "local") === "ADB2C";
    }

    getADB2CConfig = (client) => {
        const config = client.config.adb2c || {};
        return {
            auth: {
                clientId: config.appId || "",// "7709223d-ef5c-4e0b-aa5e-71b955ab4489",
                authority: `https://${config.tenant || ""}.b2clogin.com/${config.tenant || ""}.onmicrosoft.com/${config.flowId || ""}`,
                knownAuthorities: `${config.tenant || ""}.b2clogin.com,`.split(','),
                redirectUri: config.redirectUri || window.location.href.split("#")[0],
                postLogoutRedirectUri:config.redirectUri || window.location.href.split("#")[0],
                navigateToLoginRequestUrl: false
            },
            cache: {
                cacheLocation: "sessionStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level, message, containsPii) => {
                        if (containsPii) {	
                            return;	
                        }
                        switch (level) {	
                            case LogLevel.Error:	
                                console.error(message);	
                                return;	
                            case LogLevel.Info:	
                                //console.info(message);	
                                return;	
                            case LogLevel.Verbose:	
                                //console.debug(message);	
                                return;	
                            case LogLevel.Warning:	
                                //console.warn(message);	
                                return;	
                        }
                    }
                }
            }
        };
    }
}